import type { SpeakableSentence } from './speakable';

function textRange(nodes: Text[], start: number, length: number) {
  const range = document.createRange();
  let offset = 0;
  let began = false;
  for (const text of nodes) {
    if (!began && start < offset + text.length) {
      range.setStart(text, start - offset);
      began = true;
    }
    if (began && start + length <= offset + text.length) {
      range.setEnd(text, start + length - offset);
      return range;
    }
    offset += text.length;
  }
  return null;
}

/** Optional CSS Highlight API: no selection changes and no rewritten message markup. */
export function highlightSentence(messageId: string, sentence: SpeakableSentence | null) {
  if (typeof document === 'undefined') return;
  const registry = (globalThis.CSS as typeof CSS & { highlights?: Map<string, unknown> })
    ?.highlights;
  if (!registry) return;
  registry.delete('poneva-speech');
  if (!sentence?.text) return;
  const anchors = document.querySelectorAll<HTMLElement>('[data-read-aloud-message]');
  const anchor = [...anchors].find((node) => node.dataset.readAloudMessage === messageId);
  const root = anchor
    ?.closest('[data-slot="aui_assistant-message-root"]')
    ?.querySelector('[data-slot="aui_assistant-message-content"]');
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes: Text[] = [];
  let node: Node | null;
  while ((node = walker.nextNode())) nodes.push(node as Text);
  const all = nodes.map((item) => item.data).join('');
  // Locate the selected spans across Markdown blocks without rewriting message markup.
  const ranges: Range[] = [];
  let cursor = Math.min(sentence.start, all.length);
  for (const segment of sentence.segments ?? [sentence]) {
    const start = all.indexOf(segment.text, cursor);
    if (start < 0) continue;
    const range = textRange(nodes, start, segment.text.length);
    if (range) ranges.push(range);
    cursor = start + segment.text.length;
  }
  const HighlightCtor = (
    globalThis as typeof globalThis & { Highlight?: new (...ranges: Range[]) => unknown }
  ).Highlight;
  if (ranges.length && HighlightCtor) registry.set('poneva-speech', new HighlightCtor(...ranges));
}
